import { useState } from "react";
import { login } from "../firebase/services";
import IamLogo from "../components/IamLogo";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError("Email ou mot de passe incorrect.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0d2340",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      fontFamily: "'Barlow', sans-serif"
    }}>
      {/* Background pattern */}
      <div style={{
        position: "fixed", inset: 0, overflow: "hidden", zIndex: 0,
        background: "linear-gradient(160deg, #0d2340 0%, #1a3a5c 50%, #0d2340 100%)"
      }}>
        {[...Array(5)].map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            width: 300 + i * 80,
            height: 300 + i * 80,
            border: "1px solid rgba(46,134,193,0.08)",
            borderRadius: "50%",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)"
          }} />
        ))}
      </div>

      <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 380 }}>
        {/* Logo */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
          <IamLogo size={48} showText={true} />
        </div>

        {/* Card */}
        <div style={{
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: 20,
          padding: "32px 28px",
          backdropFilter: "blur(10px)"
        }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "white", marginBottom: 6, textAlign: "center" }}>
            Bienvenue
          </h1>
          <p style={{ fontSize: 14, color: "#90bde0", textAlign: "center", marginBottom: 28 }}>
            Connectez-vous à votre espace
          </p>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, color: "#90bde0", display: "block", marginBottom: 6, fontWeight: 500 }}>
                Adresse email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                style={{
                  width: "100%", padding: "12px 14px", borderRadius: 10,
                  border: "1.5px solid rgba(46,134,193,0.3)",
                  background: "rgba(255,255,255,0.08)", color: "white",
                  fontSize: 14, outline: "none", fontFamily: "inherit",
                  boxSizing: "border-box"
                }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, color: "#90bde0", display: "block", marginBottom: 6, fontWeight: 500 }}>
                Mot de passe
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{
                  width: "100%", padding: "12px 14px", borderRadius: 10,
                  border: "1.5px solid rgba(46,134,193,0.3)",
                  background: "rgba(255,255,255,0.08)", color: "white",
                  fontSize: 14, outline: "none", fontFamily: "inherit",
                  boxSizing: "border-box"
                }}
              />
            </div>

            {error && (
              <div style={{
                background: "rgba(255,80,80,0.15)", border: "1px solid rgba(255,80,80,0.3)",
                borderRadius: 10, padding: "10px 14px", marginBottom: 16,
                color: "#ffaaaa", fontSize: 13
              }}>{error}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%", padding: "14px", borderRadius: 12,
                background: loading ? "#2e5a8a" : "linear-gradient(135deg, #2e86c1, #1a5a9c)",
                color: "white", border: "none", fontSize: 15, fontWeight: 700,
                cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit",
                letterSpacing: "0.02em"
              }}
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>

        <p style={{ textAlign: "center", color: "rgba(144,189,224,0.5)", fontSize: 12, marginTop: 24 }}>
          IAM Business Group © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
